var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page background-style" }, [
    _c("div", { staticClass: "background-image-style" }),
    _vm._v(" "),
    _c("div", { staticClass: "landing-title" }, [
      _vm._v("\n        IRIS Contracts\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "landing-options" },
      [
        _vm.$store.getters.isInRoleArr(
          "View_LegalArea/LegalClient/ClientList,LEGAL,LEGAL_MNG,LEGAL_ADM,LEGAL_ASS,LEGAL_ASSISTANT_WITH_REOPEN,ADMIN"
        )
          ? _c(
              "router-link",
              {
                staticClass: "option",
                attrs: { to: "/DueDiligence", tag: "a" },
              },
              [
                _c("div", { staticClass: "img-icon-wrapper" }, [
                  _c("img", {
                    staticClass: "img-icon",
                    attrs: { src: "/static/image/Legal.svg" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("components.navigation_bar.title_due_diligence")
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("v-divider", {
          staticClass: "menu-divider",
          attrs: { vertical: "", color: "white" },
        }),
        _vm._v(" "),
        _vm.$store.getters.isInRoleArr(
          "View_ESignArea/ESign/Index,ADMIN,View_TetrisESignArea/TetrisESign/Index,JLLT_VIEW,HR_ADMIN"
        )
          ? _c(
              "router-link",
              {
                staticClass: "option",
                attrs: { to: "/LandingESign", tag: "a" },
              },
              [
                _c("div", { staticClass: "img-icon-wrapper" }, [
                  _c("img", {
                    staticClass: "img-icon",
                    attrs: { src: "/static/image/ESign.svg" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("components.navigation_bar.title_esign_minus")
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }